import { createFileRoute } from '@tanstack/react-router';
import { MemberCommunicationAnswerPage } from '@/pages/member-portal/communications/MemberCommunicationAnswerPage';

export const Route = createFileRoute('/_authenticated/_app/member-portal/communications/$id')({
	component: MemberCommunicationAnswerPage,
});
